import { Pressable, StyleSheet, View } from 'react-native';
import { Sparkles } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import type { StudyPlanTaskDraft } from '../../types/studyPlan';
import { AppButton } from '../ui/AppButton';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type PlanAiSuggestionCardProps = {
  suggestions: StudyPlanTaskDraft[];
  onUseSuggestion: (suggestion: StudyPlanTaskDraft) => void;
};

export function PlanAiSuggestionCard({
  suggestions,
  onUseSuggestion,
}: PlanAiSuggestionCardProps) {
  if (!suggestions.length) {
    return null;
  }

  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <View style={styles.iconWrap}>
          <Sparkles size={18} color={tokens.colors.primary} />
        </View>
        <View style={styles.copy}>
          <AppText variant="body" weight="bold">
            AI 计划建议
          </AppText>
          <AppText variant="caption" tone="muted">
            真实接口接入前，先用本地建议模拟自动生成任务。
          </AppText>
        </View>
      </View>

      {suggestions.map((suggestion) => (
        <Pressable
          key={`${suggestion.title}-${suggestion.subject}`}
          accessibilityRole="button"
          onPress={() => onUseSuggestion(suggestion)}
          style={({ pressed }) => [styles.suggestionRow, pressed ? styles.pressed : null]}
        >
          <View style={styles.copy}>
            <AppText variant="body" weight="semibold">
              {suggestion.title}
            </AppText>
            <AppText variant="caption" tone="muted">
              {suggestion.subject} · {suggestion.estimatedMinutes} 分钟 · {suggestion.dateId}
            </AppText>
          </View>
          <AppButton
            label="加入"
            variant="secondary"
            onPress={() => onUseSuggestion(suggestion)}
            style={styles.addButton}
          />
        </Pressable>
      ))}
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  iconWrap: {
    width: 36,
    height: 36,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  copy: {
    flex: 1,
    gap: 2,
  },
  suggestionRow: {
    minHeight: 58,
    borderRadius: tokens.radius.md,
    padding: tokens.spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
    backgroundColor: tokens.colors.background,
  },
  addButton: {
    minHeight: 34,
    paddingHorizontal: tokens.spacing.md,
  },
  pressed: {
    opacity: 0.86,
  },
});
